// 导入组件
import Vue from 'vue';
import Router from 'vue-router';

// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
// 认证页面
import autoInfo from '@/views/autoInfo';

import info from '@/views/info';
/**
 * 基础菜单
 */

//首页
import Index from '@/views/index/index';

//设备列表
import PdaList from '@/views/pdaList/pdaList';
// 物料信息
import materialInfo from '@/views/material/info';
// 出入库记录
import materialList from '@/views/material/list';
//Ai算法统计
import AiStatistics from '@/views/pdaList/aiStatistics';
// 人员设置
import personnel from '@/views/system/personnel';
// 组织机构
import organizational from '@/views/system/organizational';

//小牧丁App下载
import Xmds from '@/views/pdaList/xmds';

//暂无数据
import Nodatas from '@/views/noDatas/noDatas.vue';

//可视化大数据
import Datas from '@/views/datas/datas.vue';

//VR数字乡村
import Vr from '@/views/vr/vr.vue';
//VR数字乡村




// 用户管理


// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  mode:'history',
    routes: [{
        path: '/',
        name: '',
        component: index,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },{
        path: '/info',
        name: '',
        component: info,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/autoInfo',
        name: '',
        component: autoInfo,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },

    {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/index/index',
            name: '首页',
            component: Index,
            meta: {
                requireAuth: true
            }
        },{
            path: '/pdaList/pdaList',
            name: '设备列表',
            component: PdaList,
            meta: {
                requireAuth: true
            }
        },{
            path: '/pdaList/aiStatistics',
            name: 'Ai算法统计',
            component: AiStatistics,
            meta: {
                requireAuth: true
            }
        },{
            path: '/pdaList/xmds',
            name: '小牧丁App下载',
            component: Xmds,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/material/info',
            name: '物料信息',
            component: materialInfo,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/material/list',
            name: '出入库记录',
            component: materialList,
            meta: {
                requireAuth: true
            }
        },{
            path: '/noDatas/noDatas',
            name: '暂无',
            component: Nodatas,
            meta: {
                requireAuth: true
            }
        },{
            path: '/datas/datas',
            name: '可视化大数据',
            component: Datas,
            meta: {
                requireAuth: true
            }
        },{
            path: '/vr/vr',
            name: 'VR数字乡村',
            component: Vr,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/personnel',
            name: '人员设置',
            component: personnel,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/organizational',
            name: '人员设置',
            component: organizational,
            meta: {
                requireAuth: true
            }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js